import { useEffect } from "react";
import { Button, Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import SntCheckBox from "@cleanup/components/SntCheckBox/SntCheckBox";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { RootState } from "@/types/RootState";

interface GeneralFooterFilterProps {
  onClearFilter: () => void;
  onAppliedFilter: () => void;
  isNotFilter?: boolean;
  onCheckNotFilter?: (checked: boolean) => void;
  disableCheckBox?: boolean;
  isShowExclude?: boolean;
}

const GeneralFooterFilter: React.FC<GeneralFooterFilterProps> = ({
  onClearFilter,
  onAppliedFilter,
  isNotFilter = false,
  onCheckNotFilter,
  disableCheckBox = true,
  isShowExclude = true,
}) => {
  const language = useSelector((state: RootState) => state.language);

  useEffect(() => {
    if (disableCheckBox) {
      onCheckNotFilter?.(false);
    }
    // eslint-disable-next-line
  }, [disableCheckBox]);
  return (
    <>
      <div className="mb-3 border-top border-sensolus-grey"></div>
      <Container>
        <div className="d-flex flex-row flex-wrap">
          <div className="mb-3 flex-grow-1 align-self-center">
            {isShowExclude && (
              <>
                <SntCheckBox
                  checked={disableCheckBox ? false : isNotFilter}
                  onChange={onCheckNotFilter}
                  disabled={disableCheckBox}
                  label={
                    <label className="fw-bold">
                      {language[LanguageKey.exclude_key]}
                    </label>
                  }
                />
              </>
            )}
          </div>

          <div className="mb-3 flex-grow-1 align-self-center">
            <div className="float-end">
              <Button
                variant="outline-sensolus"
                onClick={onClearFilter}
                style={{ margin: "calc(0.5rem * 0.5)" }}
              >
                {language[LanguageKey.clear_key]}
              </Button>
              <Button variant="sensolus" onClick={onAppliedFilter}>
                {language[LanguageKey.apply_key]}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default GeneralFooterFilter;
